// src/core/inventarios/domain/aggregates/MovimientoInventario.aggregate.js

import { construirMovimientoInventarioVenta } from "../entities/MovimientoInventarioVenta.entity.js";
import { construirMovimientoInventarioAjuste } from "../entities/MovimientoInventarioAjuste.entity.js";
import { MovimientoInventarioRegistrado } from "../events/MovimientoInventarioRegistrado.event.js";

export class MovimientoInventario {
  constructor({ periodoId, createdBy }) {
    if (!periodoId)
      throw new Error("[RepositoryDriven][Aggregate] Periodo requerido");
    this.periodoId = periodoId;
    this.createdBy = createdBy;
    this.movimientos = [];
    this.events = [];
    console.log(
      "[RepositoryDriven][Aggregate] Creado Aggregate MovimientoInventario:",
      { periodoId, createdBy },
    );
  }

  // ----------------------------
  // Agregar un movimiento de venta
  // ----------------------------
  agregarVenta({ idProducto, cantidad, idReferencia }) {
    const movimiento = new construirMovimientoInventarioVenta({
      idProducto,
      cantidad,
      idReferencia,
      periodoId: this.periodoId,
      createdBy: this.createdBy,
    });

    this.movimientos.push(movimiento);

    console.log("[Aggregate] Venta agregada:", movimiento);

    return movimiento;
  }
  // ----------------------------
  // Agregar un movimiento de ajuste
  // ----------------------------
  agregarAjuste({ idProducto, cantidad, idReferencia }) {
    const movimiento = new construirMovimientoInventarioAjuste(
      idProducto,
      cantidad,
      this.periodoId,
      idReferencia,
    );
    this.movimientos.push(movimiento);
    console.log("[RepositoryDriven][Aggregate] Ajuste agregado:", movimiento);
    return movimiento;
  }

  // ----------------------------
  // Crear evento de dominio
  // ----------------------------
  crearEvento(payload) {
    const evento = new MovimientoInventarioRegistrado(payload);
    this.events.push(evento);
    console.log("[RepositoryDriven][Aggregate] Evento creado:", evento);
    return evento;
  }

  // ----------------------------
  // Limpieza de eventos despachados
  // ----------------------------
  limpiarEventos() {
    this.events = [];
    console.log("[RepositoryDriven][Aggregate] Eventos limpiados");
  }

  // ----------------------------
  // Retorna todos los movimientos agregados
  // ----------------------------
  obtenerMovimientos() {
    console.log(
      "[RepositoryDriven][Aggregate] Retornando movimientos. Total:",
      this.movimientos.length,
    );
    return this.movimientos;
  }

  // ----------------------------
  // Retorna todos los eventos pendientes
  // ----------------------------
  obtenerEventos() {
    console.log(
      "[RepositoryDriven][Aggregate] Retornando eventos. Total:",
      this.events.length,
    );
    return this.events;
  }
}
